@import "../../global/variables";


:host {
  --train-info-background: #ffffff;
}

.inner {
  padding: 0 1rem;

  @media #{$screen-min-md} {
    padding: 0 2rem;
  }
}

nj-connection {
  display: block;
  border-radius: 1px;

  &:active,
  &:focus-within,
  &:hover,
  &.connection-open {
    border-color: #888;
  }
}

.connection-header:active,
.connection-header:focus,
.connection-header:hover,
.connection-open .connection-header {
  background: #f5f5f5;
  --train-info-background: #f5f5f5;
}

.connection-header {
  border: none;
  font-family: FrutigerNextLight, Arial, Helvetica, sans-serif;
  position: relative;
  
  color: #111;
  text-decoration: none;
  text-align: left;
  width: 100%;
  font-size: 1rem;
  padding: 0;
  padding-top:1.5rem;
  display: grid;
  row-gap: 10px;
  grid-template-rows: repeat(2, min-content);

  &:disabled {
    cursor: default;

    .connection__toggle {
      margin-bottom: 0;
      min-height: 1.75rem;
    }
  }

  &:active,
  &:focus,
  &:hover {
    +.train-details-wrapper {
      border-color: #888;
    }
  }

  &.connection-header--selected {
    border: 1px solid $color-blue-20;
    background: $color-blue-10;
    --train-info-background: #EDF5FF;
  }
}

.connection-header__overview {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;
  row-gap: .5rem;

  @media #{$screen-min-sm} {
    grid-template-columns: 2fr 1.5fr;
  }

  @media #{$screen-min-md} {
    grid-template-columns: 2fr 1fr;
  }

  @media #{$screen-min-lg} {
    grid-template-columns: 5fr 1.5fr;
  }
}

.button--bordered {
  @include nj-button--bordered;
  color: $color-nightjet;
  border-color: $color-nightjet;
  margin-left:10px;
}

.connection__toggle {
  width: 100%;
  text-align: center;
  border: none;
  background-color: rgb(0, 0, 0, 0.03);
  border-radius: 0;
  color: $tint-oebb;
  fill: $tint-oebb;
  display: flex;
  margin: 0 auto;
  padding: 5px 0;
  justify-content: center;
  align-self: flex-end;
  font-size: 1rem;

  @media #{$screen-min-sm} {
    margin: 10px 0 -10px;
  }


  &-text {
    display: inline-block;
  }

  svg {
    color: $tint-oebb;
    fill: $tint-oebb;
  }
}

.connection-header--selected .connection__toggle {
  background-color: $color-white;
}

.connection-header__selection {
  fill: $color-success;

  check-icon {
    display: inline-block;
    margin-right: 10px;
  }

  svg {
    width: 25px;
    height: 22px;
  }
}

nj-information-messages {
  grid-area: 2 / 1 / 3 / 3;
}

.train-details .information-messages {
  margin-bottom: 20px;
}

@media #{$screen-min-lg} {
  .train__traveling-info {
    display: flex;
  }
}

.connection-header__selection {
  flex-basis: 25px;

  check-icon {
    margin-right: 0;
    margin-bottom: 3px;
  }
}


.train__request-date {
  padding: 5px 8px;
  margin: -2px -5px 0 ;
  color: $color-text-900;
  background: $color-green-200;
  position: absolute;
  top: -11px;
  left: 22px;
  border-radius: 3px;
  font-size: 14px;
  display: inline-flex;
  @media #{$screen-min-lg}{
    left: 2rem;
  }
  calendar-check-icon {
    margin-right: 4px;
    color: $color-success;
  }
}

.train-details-wrapper {
  height: 0;
  border-top: 0 solid #ccc;
  overflow: hidden;

  .connection-open & {
    height: auto;
    border-top-width: 1px;
    transition: height .75s ease;
  }
}

.train-details {
  display: block;
  padding: 20px 30px 30px 30px;
  box-sizing: border-box;
}

.train-details-grid {
  box-sizing: border-box;
  display: none;

  table {
    margin-bottom: 20px;
  }

  @media #{$screen-min-md} {
    display: grid;
    grid-template-columns: auto 60%;
    grid-gap: 40px;

    table {
      margin-bottom: 0;
    }
  }
}

table.train-route {
  width: 100%;

  border-collapse: collapse;

  caption {
    font-size: 16px;
    font-weight: bold;
    text-align: left;
  }

  tr {
    padding: 80px 0;
  }

  th {
    vertical-align: bottom;

    border-bottom: 1px solid $color-blue-gray;
  }

  td {
    padding: 6px 0;
    vertical-align: middle;

    border-bottom: 1px solid $color-papyrus-white;
  }

  tr:last-child td {
    border-bottom: 0;
  }

  th:first-child,
  td:first-child {
    min-width: 125px;
    padding-left: 25px;
  }

  td:first-child {
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 8px;
      bottom: 0;

      content: '';
      display: block;
      width: 2px;
      height: 100%;

      background: $color-blue-gray;
    }

    &::after {
      position: absolute;
      top: 50%;
      left: 5px;

      content: '';
      display: block;
      width: 8px;
      height: 8px;

      background: $color-blue-gray;
      border-radius: 50%;
      transform: translateY(-50%)
    }
  }

  tr:first-child td:first-child::before {
    top: auto;
    bottom: 0;

    height: 50%;
    min-height: 0;
  }

  tr:last-child td:first-child::before {
    top: 0;
    bottom: auto;

    height: 50%;
    min-height: 0;
  }

  .train-route__arr,
  .train-route__dep {
    text-align: center;
  }

  .train-route__dep {
    font-weight: bold;
  }
}

.train-details-offer {
  display: block;
  margin-bottom: 20px;
}



.segment {
  display: flex;
  flex-direction: column;

  margin-bottom: 40px;

  @media #{$screen-min-md} {
    flex-direction: row;
  }

  >section {
    margin-bottom: 40px;

    @media #{$screen-max-md} {
      &:last-child {
        margin-bottom: 0;
      }
    }

    @media #{$screen-min-md} {
      display: flex;
      flex-direction: column;

      width: 33.33%;
      margin-right: 24px;
      margin-bottom: 0;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.accommodation {
  transition: background-color .3s ease;
  box-shadow: 0 0 1em #dce1e6;
  padding-bottom: 16px;
  border-radius: 6px;
  overflow: hidden;

  &:hover,
  &:focus {
    background-color: #f5f5f5;
    //border: 1px solid #888;

    &.accommodation-has-offers {
      cursor: pointer;
    }
  }
}

.offer-data {
  grid-area: 1 / 2 / 2 / 3;

  border-left: 1px solid $color-cool-grey-20;
  height: calc(100% - 4px);
  padding: 10px 0;

  > div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;
  }

  &__warnings {
    text-align: right;
    margin: 0 .625rem;
  }

  &__warning-message {
    font-weight: 700;
    display: block;
    margin-bottom: .625rem;
  }

  &__warning-link {
    display:  inline-block;
    color: currentColor;
    border: 1px solid $color-warm-grey-70;
    padding: .25rem .5rem;
    margin-top: .5rem;
    border-radius: 2px;
  }
}

.segment__title {
  margin-top: 0;
  margin-bottom: 16px;

  font-size: 20px;
}

.accommodation__title {
  margin-top: 0;

  border-bottom: 1px solid $color-blue-gray;
  background-color: $color-traffic-nightjet;
  color: #FFFFFF;
  padding: 8px 16px;
  font-size: 1.25em;

  display: flex;
  gap: 12px;

  &--EN {
    background-color: $tint-euronight;
  }
}

.accommodation__detail {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;

  padding-left: 16px;
  padding-right: 16px;

  >div.accommodation__text>ul {
    list-style: disc;
    line-height: 121%;
    padding-left: 21px;

    >li {
      margin-bottom: 2px;
    }
  }

  >div.accommodation__text>ul.accommodation__text-highlighted-properties {
    padding-left: 0;

    >li {
      background: var(--asset-url-icon-icon_check_list_style-svg) no-repeat left center;
      list-style: none;
      margin: 0 0 2px;
      padding-left: 21px;
      font-weight: bold;
    }

    >li:last-child {
      margin-bottom: 8px;
    }
  }
}

.accommodation__image {
  img {
    max-width: 100%;
    height: auto;
  }
}

.accommodation__image-gallery {
  display: block;
}

.accommodation-overview__image {
  aspect-ratio: 1.6;
}

.accommodation__text {
  margin-bottom: 16px;

  ul {
    padding-left: 16px;
  }
}

.accommodation__price-action {
  margin-top: auto;

  .button--primary {
    @include nj-button;
    @include nj-button--sm;

    margin-top: 4px;
    margin-left: 0;

    fill: $color-white;
    font-size: 18px;
    line-height: 18px;

    svg {
      margin-right: 8px;
    }
  }

  .full-height-button {
    @media #{$screen-max-md} {
      justify-content: center;
      height: 100%;
    }
  }

  .full-width-button {
    width: 100%;
    justify-content: center;
  }

  .button--secondary {
    @include nj-button-secondary;
    @include nj-button--sm;

    margin-top: 4px;
    margin-left: 0;

    color: $colour-nightjet-accent;
    border-color: $colour-nightjet-accent;
    font-size: 16px;
    line-height: 18px;
  }

  button.btn-no-border-radius {
    border-radius: 0;
  }
}

.accommodation__price {
  display: contents;
  margin: 0;
  margin-bottom: 8px;
}

.accommodation__price-grid {
  width: 100%;

  display: grid;
  grid-template-columns: 1fr auto;
  gap: 6px;

  @media #{$screen-min-md} {
    justify-items: start;
    align-items: end;
  }

  @media #{$screen-max-md} {
    align-items: center;
  }
}

.accommodation__price-from {
  display: inline-block;

  @media #{$screen-max-md} {
    text-align: left;
  }
}

.accommodation__price-value-container {
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-end;
  gap: 6px;
}

.accommodation__price-value {
  font-size: 1.35rem;
  font-weight: bold;

  color: $colour-nightjet-accent;
}

.compartment-booking-information-link {
  @include nj-back-link;
  border: none;
  text-align: left;
  padding: 0;
  text-decoration: underline;
}

.price-disclaimer {
  margin: 0;
  text-align: center;
  font-size: smaller;
}

.accommodation .gallery-slider-embedded {
  cursor: default;

  .gallery-slider {
    &-header {
      display: none;
    }

    &-caption {
      top: 0;
      bottom: unset;
      opacity: 1;
      transition: unset;
      background: radial-gradient(135.84% 6944.44% at 100% 50%, #DDE1E6 0%, rgba(221, 225, 230, 0) 100%);
      text-align: right;
      color: black;
      padding: 0.5rem 1rem;
    }

    &-copyright {
      display: none;
    }

    &-media {
      // Give the image a slightly larger radius than the container, there are some rendering issues with the gradient otherwise
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }

    &-enlarge {
      transform: unset;
      top: unset;
      left: unset;
      bottom: 0.25rem;
      right: 0.25rem;
      font-size: 1rem;
    }
  }
}